import React, { FC } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Theme, Typography } from '@material-ui/core';
import Content from 'containers/common/sections/privacy/Content';
import { PageLink } from 'components/common/atoms';
import useI18n from 'evcharging/hooks/useI18n';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    marginTop: 140,
  },
  rootName: {
    fontWeight: 600,
    fontSize: 24,
    color: theme.palette.primary.main,
    lineHeight: 1.5,
    paddingRight: theme.spacing(0.8),
  },
}));

const PrivacyPolicy: FC = () => {
  const { t } = useI18n();

  const styles = useStyles();

  return (
    <>
      <Grid className={styles.root} container>
        <Grid item>
          <Typography className={styles.rootName}>
            <PageLink href={'/'} rel="noreferrer">
              {t('nav.home')} /
            </PageLink>
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="h1" className={styles.rootName}>
            {t('nav.privacy')}
          </Typography>
        </Grid>
      </Grid>
      <Content
        listItems={[
          t('privacy.text1'),
          t('privacy.text2'),
          t('privacy.text3'),
        ]}
      />
      <Content
        title={t('privacy.consent')}
        listItems={[t('privacy.consent.text1')]}
      />

      <Content
        title={t('privacy.info')}
        listItems={[
          t('privacy.info.text1'),
          t('privacy.info.text2'),
          t('privacy.info.text3'),
        ]}
      />

      <Content
        title={t('privacy.disclosure')}
        listItems={[
          t('privacy.disclosure.text1'),
          t('privacy.disclosure.text2'),
        ]}
      />

      <Content
        title={t('privacy.sms')}
        listItems={[
          t('privacy.sms.text')
        ]}
      />

      <Content
        title={t('privacy.how')}
        listItems={[
          t('privacy.how.text1'),
          t('privacy.how.text2'),
          t('privacy.how.text3'),
          t('privacy.how.text4'),
          t('privacy.how.text5'),
          t('privacy.how.text6'),
          t('privacy.how.text7'),
          t('privacy.how.text8'),
          t('privacy.how.text9'),
          t('privacy.how.text10'),
          t('privacy.how.text11'),
          t('privacy.how.text12'),
          t('privacy.how.text13'),
        ]}
      />

      <Content
        title={t('privacy.log')}
        listItems={[t('privacy.log.text1')]}
      />
      <Content
        title={t('privacy.cookies')}
        listItems={[t('privacy.cookies.text1')]}
      />

      <Content
        title={t('privacy.ccpa')}
        listItems={[
          t('privacy.ccpa.text1'),
          t('privacy.ccpa.text2'),
          t('privacy.ccpa.text3'),
          t('privacy.ccpa.text4'),
          t('privacy.ccpa.text5'),
        ]}
      />

      <Content
        title={t('privacy.gdpr')}
        listItems={[
          t('privacy.gdpr.text1'),
          t('privacy.gdpr.text2'),
          t('privacy.gdpr.text3'),
          t('privacy.gdpr.text4'),
          t('privacy.gdpr.text5'),
          t('privacy.gdpr.text6'),
          t('privacy.gdpr.text7'),
          t('privacy.gdpr.text8'),
        ]}
      />
      <Content
        title={t('privacy.children')}
        listItems={[
          t('privacy.children.text1'),
          t('privacy.children.text2'),
        ]}
      />
    </>
  );
};

export default PrivacyPolicy;
